
async function refreshCartDrawer() {
  const resDrawer = await fetch(`/${Shopify.locale}/?section_id=cart-drawer`);
  const htmlDrawer = await resDrawer.text();
  const newDrawer = new DOMParser()
    .parseFromString(htmlDrawer, 'text/html')
    .querySelector('#CartDrawer');

  if (newDrawer) {
    const oldDrawer = document.querySelector('#CartDrawer');
    oldDrawer?.replaceWith(newDrawer);
  }

  const updatedDrawer = document.querySelector('cart-drawer');
  updatedDrawer?.classList.add('active');
  updatedDrawer?.classList.remove('is-empty');
  document.body.classList.add('overflow-hidden');
}

async function updateCartBubbleCount() {
  const cart = await fetch('/cart.js').then(res => res.json());
  const count = cart.item_count;

  const bubble = document.querySelector('.cart-count-bubble');
  if (!bubble) return;
  const bubbleCount = bubble.querySelector('[aria-hidden="true"]');

  if (count > 0) {
    bubbleCount.textContent = count;
  } else {
    bubbleCount.textContent = '';
  }
}

function initStickyBoostProxy() {
  const stickyForm = document.querySelector('.sticky-form');
  const stickyQty = stickyForm?.querySelector('input[name="quantity"]');
  const boostForm = document.querySelector('.boost-sd__product-form');
  const boostQty = boostForm?.querySelector('input[type="number"]');
  const boostAddBtn = boostForm?.querySelector('.boost-sd__button--purchase');

  stickyQty?.addEventListener('input', () => {
    boostQty.value = stickyQty.value;
    boostQty.dispatchEvent(new Event('input', { bubbles: true }));
  });

  boostQty.addEventListener('input', () => {
    stickyQty.value = boostQty.value;
  });

  stickyForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    boostQty.value = stickyQty.value;
    boostQty.dispatchEvent(new Event('input', { bubbles: true }));

    boostAddBtn.click();

    setTimeout(async () => {
      await refreshCartDrawer();
      updateCartBubbleCount();
    }, 600);
  });
}
function waitForBoostAndInitSticky() {
  if (document.querySelector('.boost-sd__product-form')) {
    initStickyBoostProxy();
    return;
  }

  const observer = new MutationObserver((_, obs) => {
    if (document.querySelector('.boost-sd__product-form')) {
      obs.disconnect();
      initStickyBoostProxy();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}


document.addEventListener('click', (e) => {
  const btn = e.target.closest('.boost-sd__button--purchase, .boost-sd__button--preorder');
  if (!btn) return;

  setTimeout(async () => {
    await refreshCartDrawer();
    updateCartBubbleCount();
  }, 600);
});

waitForBoostAndInitSticky();
